
<a-select
  class="comparison-select"
  :options="typeOptions"
  v-model.sync="localValue"
  :is-searchable="false"
  btn-color="clear-area"
  :has-teleport="!outsideModal">
</a-select>
